<template>
  <!-- 添加服务人员 -->
  <div class="container">
    <div class="vue padHorizontal10">
      <div class="header  flex flexJc-sb flexAi-c">
        <div class="text">选择服务人员</div>
        <div class="padR10">
          <el-button size="mini" @click="goBack" icon="el-icon-back"
            >返回</el-button
          >
        </div>
      </div>
      <div class="service flex  flexWrap">
        <div class="choose " v-for="(item, index) in chooselist" :key="index">
          <div
            @click="tabChoose(index, item)"
            class="list padVertical10 flex flexColumn flexAi-c flexJc-c"
            :class="chooseI === index ? 'newchoose_bg' : 'choose_bg'"
          >
            <div class="header">
              <el-image
                style="width: 100px; height: 100px"
                :src="item.image"
                fit="cover"
              ></el-image>
            </div>
            <div class="center">
              {{ item.servername }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="dialog">
      <el-dialog
        title="提示"
        :modal-append-to-body="false"
        :visible.sync="dialogVisible"
        width="50%"
        @closed="closed">
        <div style="padding: 10px;">擅长领域:{{ serviceSpecialize }}</div>
        <el-tabs v-model="activeName" @tab-click="tabChange">
          <el-tab-pane
            :label="item.name"
            :name="item.value"
            v-for="(item, index) in WorkList"
            :key="index"
          >
            <div class="time-data flex flexAi-c flexWrap">
              <div
                @click="TimeClick(value, i)"
                class=" flex flexJc-c"
                :class="[
                  value.isZy === true ? 'time-occupy' : 'time-list',
                  value.isZy === false && i === TimeI ? 'time-list-click' : ''
                ]"
                v-for="(value, i) in WorkTimeList"
                :key="i"
              >
                {{ value.canworktime }}
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogClick">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  apiGetServerList,
  apiGetServerWorkTime,
  apiServerAssign
} from '@/api/orderManage'
let that
export default {
  name: '',
  props: [''],

  data() {
    return {
      routerObj: '', // 传参的数据
      chooselist: [], // 列表
      chooseI: Number,
      activeName: 'first',
      dialogVisible: false,
      WorkList: [
        { name: '今天', value: 'first' },
        { name: '明天', value: 'second' },
        { name: '后天', value: 'third' }
      ], // 时间-选项卡列表
      TimeI: Number,
      timeRow: '',
      WorkTimeList: [],
      timeDtlList: [],
      serviceSpecialize: ''
    }
  },
  computed: {},

  beforeMount() {},

  mounted() {
    that = this
    if (this.$route.query.info !== undefined) {
      this.headText = '编辑服务人员'
      this.routerObj = JSON.parse(this.$Base64.decode(this.$route.query.info))
      this.GetServiceList()
    }
  },

  methods: {
    // 返回
    goBack() {
      this.$router.go(-1)
    },
    // 点击服务人员
    tabChoose(index, item) {
      console.log(item)
      this.serviceSpecialize = item.serviceSpecialize;
      // 接口-获取服务人员
      apiGetServerWorkTime({
        sid: item.id
      }).then(res => {
        if (res.status === 0) {
          // 这种写法防止原数据被修改当使用foreach时添加数据会改变原数据会影响判断
          // 所以需要用这种转换方法
          that.WorkTimeList = JSON.parse(JSON.stringify(res.data.time))
          that.timeDtlList = JSON.parse(JSON.stringify(res.data.timeDtl))
          /** 每次打来弹窗看到的都是当天的所以用当天的进行比较
           * isuse=1 该时间段被占用
           * today.date === that.datetime 等于当前时间时设置true
           * 为true时用户不可选择
           */
          // 赋一个今天零点值的时间戳
          that.datetime = new Date(new Date().setHours(0, 0, 0, 0)) / 1000
          this.dialogVisible = true
          that.datetime = that.datetime.toString()
          that.WorkTimeList.forEach((element, i) => {
            element.isZy = false
            that.timeDtlList.forEach((today, toindex) => {
              if (
                element.id === today.wid &&
                today.isuse === 1 &&
                today.date === that.datetime
              ) {
                element.isZy = true
              }
            })
          })
          console.log(that.WorkTimeList)
        }
      })
    },
    /** 弹窗 */
    // 选择时间
    TimeClick(value, i) {
      this.TimeI = i
      if (!value.isZy) {
        this.timeRow = value
        console.log(value)
      }
    },
    // 弹窗--确定
    dialogClick() {
      if (!this.timeRow) {
        this.$Me('选择时间段才可确认')
      } else {
        console.log(this.timeRow)
        apiServerAssign({
          indentId: this.routerObj.id,
          sid: this.timeRow.uid,
          workTimeId: this.timeRow.id,
          date: that.datetime
        }).then(res => {
          if (res.status === 0) {
            this.$Ms(res.msg)
            setTimeout(() => {
              this.$router.go(-1)
            }, 1000)
          } else if (res.status === 1) {
            this.$Me(res.msg)
          }
        })
        console.log(that.datetime)
      }
    },
    // 弹窗--关闭
    closed() {
      this.TimeI = Number
      this.timeRow = ''
      this.activeName = 'first'
    },
    // 今天-明天-后天时间切换时触发
    tabChange() {
      that.TimeI = Number
      this.timeRow = ''
      const timenow = new Date(new Date().setHours(0, 0, 0, 0)) / 1000
      switch (that.activeName) {
        case 'first':
          that.datetime = timenow
          break
        case 'second':
          that.datetime = timenow + 86400
          break
        case 'third':
          that.datetime = timenow + 86400 * 2
          break
        default:
          break
      }
      that.datetime = that.datetime.toString()
      console.log(that.datetime)
      that.WorkTimeList.forEach((element, i) => {
        element.isZy = false
        that.timeDtlList.forEach((today, toindex) => {
          if (
            element.id === today.wid &&
            today.isuse === 1 &&
            today.date === that.datetime
          ) {
            element.isZy = true
          }
        })
      })

      console.log(that.WorkTimeList)
    },
    // 接口
    // 获取服务人员的列表
    GetServiceList() {
      apiGetServerList({
        lng: this.routerObj.lng,
        lat: this.routerObj.lat,
        cateType: this.routerObj.cateType
      }).then(res => {
        if (res.status === 0) {
          this.chooselist = res.data
          // res.data
        } else {
          this.$message({type: 'error', message: res.msg})
        }
      })
    }
  },

  watch: {}
}
</script>
<style lang="scss" scoped>
.vue {
  background-color: #fff;
  border-left: 2px solid #119685;
  .header {
    .text {
      text-align: left;
      // font-size: 0.875em;
      color: #119685;
      padding: 10px 5px;
    }
  }
  .service {
    .choose {
      padding: 10px 0;
      width: 20%;
      .list {
        border: 1px solid #fff;
      }
      .list:hover {
        border: 1px solid #119685;
      }
    }
  }
}
/deep/ .time-data {
  .time-list {
    padding: 10px 0;
    width: 20%;
    border: 1px solid #fff;
  }
  .time-list {
    cursor: pointer;
  }
  .time-list:hover {
    color: #119685;
  }
  .time-list-click {
    border: 1px solid #119685;
    color: #119685;
  }
  .time-occupy {
    padding: 10px 0;
    width: 20%;
    border: 1px solid #fff;
    border: 1px solid #f3f3f3;
    color: #bdbdbd;
    cursor: not-allowed;
  }
}
</style>
